import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import {
  Fab,
  withMobileDialog,
} from '@material-ui/core';
import FeedbackIcon from '@material-ui/icons/Feedback';
import { openSupportRequestModal } from '@pingum/app-state-management/supportRequest/actions';

export const styles = () => ({
  fab: {
    color: 'white',
    marginLeft: 6,
  },
  container: {
    cursor: 'pointer',
    marginTop: '1em',
  },
  label: {
    padding: '0 16px',
    fontSize: '16px',
    fontWeight: 500,
  },
});

export const FeedbackButtonComponent = (props) => (
  <div
    onClick={props.openSupportRequestModal}
    role="button"
    tabIndex={-1}
    onKeyPress={props.openSupportRequestModal}
    className={props.classes.container}
  >
    <Fab
      color="primary"
      aria-label="Feedback"
      className={props.classes.fab}
      size="small"
    >
      <FeedbackIcon />
    </Fab>
    <span className={props.classes.label}>Feedback</span>
  </div>
);

FeedbackButtonComponent.propTypes = {
  openSupportRequestModal: PropTypes.func,
  classes: PropTypes.object,
};

FeedbackButtonComponent.defaultProps = {
  openSupportRequestModal: () => {},
  classes: {},
};

export const mapStateToProps = (state) => ({ hide: state.dashboard.showDashboardFilter });

export const mapDispatchToProps
  = (dispatch) => ({ openSupportRequestModal: () => dispatch(openSupportRequestModal()) });

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles)(withMobileDialog({ breakpoint: 'xs' })(FeedbackButtonComponent)));
